import Button from 'devextreme-react/button';

interface DashboardCardLinkButtonProps {
  text: string;
  href: string;
}

export function DashboardCardLinkButton({ text, href }: DashboardCardLinkButtonProps) {
  return (
    <Button
      text={text}
      type="default"
      stylingMode="contained"
      onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
    />
  );
}
